import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import {  useSelector } from 'react-redux';
import { App, ConfigProvider, ThemeConfig } from 'antd';

// helpers
import './i18n';

// services
import { RootState } from 'stores/store';
import { NotificationHolder } from 'core/services/notification';

//components
import NotFoundPage from 'components/404/notFound';

//routes
import { BusinessRoutes } from 'routes/businessRoutes';
import { MainRoutes } from 'routes/mainRoutes';

const router = createBrowserRouter([...MainRoutes, ...BusinessRoutes, { path: '*', element: <NotFoundPage /> }]);

function Main() {
	const language = useSelector((state: RootState) => state.language);

	const theme: ThemeConfig = {
		token: {
			colorPrimary: '#2884EF',
			colorPrimaryActive: '#3689eb',
			colorSuccess: '#50CD89',
			colorError: '#ff4d4f',
			borderRadius: 6,
			colorBgContainer: '#f9fafb',
			green: '#18db5a',
		},
	};

	return (
		<ConfigProvider componentSize="large" theme={theme} direction={language == 'ar' ? 'rtl' : 'ltr'}>
			<App component={false}>
				<NotificationHolder />
				<RouterProvider router={router} />
			</App>
		</ConfigProvider>
	);
}

export default Main;
